@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.label-history-section-content {
  padding: @space-0 @space-16 @space-24;
  height: 100%;
  overflow: hidden auto;
}

.label-history-section-header {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon {
  height: 16px;
  width: 16px;
}

.label-history-item-head,
.label-history-item-content {
  display: grid;
  font-size: 12px;
  grid-template-columns: @space-16 1fr;
  gap: @space-8;
}

.link-button {
  font-size: 12px;
}

.planning-rate-card {
  background: var(--default--background-color-18);
  border-color: var(--default--border-color--15);
  border-radius: 8px;
  margin: 2px @space-0 @space-8;
  min-height: 48px;
  display: grid;
  gap: @space-12;
  grid-template-columns: 42px 1fr 60px 16px;
  align-items: flex-start;
  padding-right: @space-12;
}

.history-connector {
  height: 85%;
  width: 1px;
  background: var(--grey-400);
  margin: auto;
}

.label-history-cost {
  color: var(--grey-600);
  font-size: 12px;
  font-weight: 500;
}

.zero-cost {
  color: var(--grey-600);
}

.zero-cost-override {
  color: @white;
}

.zero-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.no-provider {
  color: @white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-0 @space-8;
}

.no-provider-text {
  font-size: 14px;
}

.shipment-actions-button-icon,
.shipment-actions-disabled,
.shipment-actions {
  width: 16px;
  height: 16px;
  color: var(--light--icon--fill-color--1);
}

.shipment-actions {
  color: @white;
}

.shipment-actions-disabled {
  color: var(--grey-600);
}

.provider-logo {
  height: 32px;
  width: 32px;
  background: @white;
  margin: @space-8;
  padding: 3px; // no space variable for this, value came from mocks
  border-radius: 6px;
}

.service-name,
.label-rate {
  font-size: 16px;
  font-weight: 500;
  color: @white;
  .truncate();
  margin: @space-4 @space-0;
}

.label-rate {
  font-weight: 400;
  text-align: right;
  &.reduce-pad {
    padding: @space-4 @space-0 @space-0;
  }
}

.actions-dropdown {
  margin-top: @space-8;
}

.actions-toggler {
  background-color: inherit;
  border: none;
}

.service-and-tracking,
.label-rate {
  padding: @space-8 @space-0;
}
